import GmapCluster from '@/core/service/googleMaps/components/GmapCluster/GmapCluster.vue';
import GmapClusterRadius from '@/core/service/googleMaps/components/GmapClusterRadius/GmapClusterRadius.vue';
import GmapMap from '@/core/service/googleMaps/components/GmapMap/GmapMap.vue';
import GmapMarker from '@/core/service/googleMaps/components/GmapMarker/GmapMarker.vue';
import GmapQuadrilateral from '@/core/service/googleMaps/components/GmapQuadrilateral/GmapQuadrilateral.vue';

/**
 * Google Maps Plugin - Component Registration Only
 *
 * This plugin only registers the Google Maps Vue components globally.
 * The actual Google Maps API is loaded lazily via useGoogleMaps() composable
 * when components that need it are mounted.
 *
 * This improves performance by not loading Google Maps on pages that don't use it.
 */
export default defineNuxtPlugin({
	name: 'google-maps-components',
	setup(nuxtApp) {
		// Register Google Maps components globally
		nuxtApp.vueApp.component('GmapMap', GmapMap);
		nuxtApp.vueApp.component('GmapMarker', GmapMarker);
		nuxtApp.vueApp.component('GmapCluster', GmapCluster);
		nuxtApp.vueApp.component('GmapClusterRadius', GmapClusterRadius);
		nuxtApp.vueApp.component('GmapQuadrilateral', GmapQuadrilateral);

		// Note: Google Maps API is now loaded lazily via useGoogleMaps() composable
		// Components that need the API should call:
		//   const { init, api } = useGoogleMaps();
		//   await init();
	}
});
